import App from './App.svelte';
// if (!location.host.includes('localhost')) {
//   window.onbeforeunload = function () {
//     return 'Leaving the page may cause your work to be lost.';
//   };
// }
const app = new App({
    target: document.body
});
export default app;
